<template>
  <GwMenu @open="loadNolt">
    <template #opener>
      <div class="position-relative">
        <div
          class="mdi mdi-help-circle-outline tpmen_icon icon_btn csst csst_nm"
          tour="help"
        >
          <div
            class="csst_content pa-2 text-nowrap"
            style="transform: translate(0, 2.5rem)"
            v-html="$t('common.help')"
          ></div>
        </div>
        <div
          v-if="freshChatMessages"
          class="notifCircle"
        >
          {{ freshChatMessages > 99 ? '99+' : freshChatMessages }}
        </div>
      </div>
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu f-column"
        style="padding: 0.5rem 0"
        @click="methods.toggleOpen(false)"
      >
        <a
          v-if="!$i18n.g1 && links_url_links_byPageGuide"
          :href="links_url_links_byPageGuide.url"
          target="_blank"
          data-tst="menu_item_tutorial"
        >
          <NavCard
            class="navcard_appbar"
            :item="{
              icon: 'mdi-book-information-variant',
              title: links_url_links_byPageGuide.text,
            }"
          />
        </a>
        <NavCard
          v-if="!$i18n.g1"
          class="navcard_appbar"
          :item="{ icon: 'mdi-help-circle', title: $t('common.start_tour') }"
          dataTst="menu_item_tutorial"
          @click="$store.dispatch('router_set_dialogs', 'tours-dialog')"
        />
        <a
          v-if="!$i18n.g1"
          :href="links_url_links.help_center.url"
          target="_blank"
          data-tst="menu_item_tutorial"
        >
          <NavCard
            v-if="!$i18n.g1"
            class="navcard_appbar"
            :item="{
              icon: links_url_links.help_center.icon,
              title: links_url_links.help_center.text,
            }"
          />
        </a>

        <a
          :href="links_url_links.discord_invite.url"
          target="_blank"
          data-tst="menu_item_discord"
        >
          <!-- TODO Vue3 add discord icon? -->
          <NavCard
            v-if="!$i18n.g1"
            class="navcard_appbar"
            :item="{
              icon: 'mdi-discord',
              title: $t('common.get_help_discord'),
            }"
          />
        </a>

        <NavCard
          v-if="$store.getters.user_has_flag('CHAT_WIDGET')"
          class="navcard_appbar"
          :item="{
            title: $t('common.chat_with_us'),
          }"
          @click="openChat"
        >
          <template #icon>
            <div class="position-relative">
              <div class="mdi mdi-chat"></div>
              <div
                v-if="freshChatMessages"
                class="notifCircle"
              >
                {{ freshChatMessages > 99 ? '99+' : freshChatMessages }}
              </div>
            </div>
          </template>
        </NavCard>
        <NavCard
          v-if="$store.getters.user_has_flag('NOLT')"
          class="navcard_appbar init_nolt_btn"
          :item="{
            icon: 'mdi-comment-edit',
            title: $t('common.make_a_suggestion'),
          }"
        />
        <a href="mailto:hello@gtowizard.com">
          <NavCard
            class="navcard_appbar"
            :item="{
              icon: 'mdi-email',
              title: $t('common.email'),
            }"
          />
        </a>
      </div>
    </template>
  </GwMenu>
</template>
<script>
import links_mix from '@/mixins/links_mix'
import GwMenu from '@/components/lib/GwMenu'
import { openChat } from '@gto/widgets/fresh-chat'
import { loadNoltWidget } from '@gto/widgets/nolt'
import { globalStore } from '@gto/gw-store'

export default {
  name: 'HelpMenu',
  components: { GwMenu },
  mixins: [links_mix],
  props: {
    asBlocks: Boolean,
    itemStyle: {
      type: String,
      default: () => '--height: 3rem; --clr-tag-back: var(--clr-black-4)',
    },
    itemClass: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    openChat,
    loadNolt() {
      if (!this.$store.getters.user_has_flag('NOLT')) return
      loadNoltWidget()
    },
  },
  computed: {
    freshChatMessages() {
      return globalStore.getState().freshChatMessages
    },
  },
}
</script>

<style lang="scss" scoped>
.notifCircle {
  position: absolute;
  border-radius: 1rem;
  top: 0;
  right: 0;
  transform: translate(50%, 0);
  font-size: 0.7rem;
  z-index: 4;
  color: black;
  background: var(--clr-primary);
  padding: 2px;
  min-width: 0.875rem;
  text-align: center;
  box-shadow: var(--menu-shadow);
  height: 1rem;
  line-height: 1;
}
</style>
